import { render, staticRenderFns } from "./CondonacionesQuitas.vue?vue&type=template&id=2c2e2674&"
import script from "./CondonacionesQuitas.vue?vue&type=script&lang=js&"
export * from "./CondonacionesQuitas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports